import { Component, OnInit } from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {IconService} from '../../services/icon.service';
import {Router} from '@angular/router';
import {StoreService} from '../../services/store.service';

@Component({
  selector: 'profile-top',
  templateUrl: './profile-top.component.html'
})
export class ProfileTopComponent implements OnInit {

  // collaborators: any[] = [
  //   {
  //     name: 'Administrator',
  //     role: 'admin',
  //     active: true
  //   },
  //   {
  //     name: 'Moderator',
  //     role: 'moder',
  //   }
  // ];

  constructor(public iconService: IconService,
              public storeService: StoreService,
              private _authService: AuthService,
              private _router: Router) {

  }

  ngOnInit() {
  }

  logOut() {
    this._authService.logOut().subscribe(() => {
      this.storeService.mutations.setAuth(false);
      this._router.navigate(['login']);
    });
  }
}
